import { AppBar, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AppBarBottom = styled(AppBar)({
  top: 'auto',
  bottom: 0,
  backgroundColor: '#ff9102',
  height: 61,
});

export const AppBarTypography = styled(Typography)({
  fontSize: 24,
  display: 'inline-block',
});

type FontSizeTypographyProps = {
  isSmallFont?: boolean;
};

export const GrayTypography = styled(Typography)<FontSizeTypographyProps>(({ isSmallFont }) => ({
  color: 'gray',
  fontSize: isSmallFont ? '14px' : '16px',
}));

export const PriceTypography = styled(Typography)<FontSizeTypographyProps>(({ isSmallFont }) => ({
  minWidth: '60px',
  fontSize: isSmallFont ? '14px' : '16px',
  textAlign: 'right',
}));

export const PriceGrayTypography = styled(PriceTypography)({
  color: 'gray',
});

export const AddServiceButton = styled(Button)(({ theme }) => ({
  color: theme.palette.button.primary.color,
  backgroundColor: theme.palette.button.primary.background,
  '&:hover': {
    backgroundColor: theme.palette.button.primary.backgroundHover,
  },
  width: '17vh',
  borderRadius: 10,
}));
